import { forkJoin, of } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { map, mergeMap, tap } from 'rxjs/operators';
// NGRX
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// Services
import { PickingService } from '../_services/';
// State
import { AppState } from '../../reducers';
// Actions
import {
	OnePickingDeleted,
	PickingActionTypes,
	PickingCreated,
	PickingOnServerCreated,
	PickingPageLoaded,
	PickingPageRequested,
	PickingPageToggleLoading,
	PickingUpdated
} from '../_actions/picking.actions';

@Injectable()
export class PickingEffects {
	showPageLoadingDistpatcher = new PickingPageToggleLoading({isLoading: true});
	showLoadingDistpatcher = new PickingPageToggleLoading({isLoading: true});
	hideActionLoadingDistpatcher = new PickingPageToggleLoading({isLoading: false});

	@Effect()
	loadPickingPage$ = this.actions$
		.pipe(
			ofType<PickingPageRequested>(PickingActionTypes.PickingPageRequested),
			mergeMap(({payload}) => {
				this.store.dispatch(this.showPageLoadingDistpatcher);
				const requestToServer = this.pickingService.findPicking(payload.page);
				const lastQuery = of(payload.page);
				return forkJoin(requestToServer, lastQuery);
			}),
			map(response => {
			    /*
			    Workaround: create new id, because many rows have the same id and angular table can't display two or more rows with the same id.
			     */
			    let list = response[0].items;
                for (let i = 0; i < list.length; i++) {
                    list[i].id = i;
                }
                /*
                 */
				const result: QueryResultsModel = response[0];
				const lastQuery: QueryParamsModel = response[1];
				return new PickingPageLoaded({
					// Picking: result.items,
                    Picking: list,
                    totalCount: result.totalCount,
					page: lastQuery
				});
			}),
		);

	// @Effect()
	// deletePicking$ = this.actions$
	// 	.pipe(
	// 		ofType<OnePickingDeleted>(PickingActionTypes.OnePickingDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.orderEventsService.deletePicking(payload.id);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// deletePicking$ = this.actions$
	// 	.pipe(
	// 		ofType<ManyPickingDeleted>(PickingActionTypes.ManyPickingDeleted),
	// 		mergeMap(({payload}) => {
	// 				this.store.dispatch(this.showLoadingDispatcher);
	// 				return this.orderEventsService.deletePicking(payload.ids);
	// 			}
	// 		),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updatePickingStatus$ = this.actions$
	// 	.pipe(
	// 		ofType<PickingStatusUpdated>(PickingActionTypes.PickingStatusUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.updateStatusForPicking(payload.Picking, payload.status);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// updatePicking$ = this.actions$
	// 	.pipe(
	// 		ofType<PickingUpdated>(PickingActionTypes.PickingUpdated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.updatePicking(payload.Picking, payload.Picking.id); // TODO: fix this
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// createPicking$ = this.actions$
	// 	.pipe(
	// 		ofType<PickingOnServerCreated>(PickingActionTypes.PickingOnServerCreated),
	// 		mergeMap(({payload}) => {
	// 			this.store.dispatch(this.showLoadingDispatcher);
	// 			return this.orderEventsService.createPicking(payload.Picking).pipe(
	// 				tap(res => {
	// 					this.store.dispatch(new PickingCreated({Picking: res}));
	// 				})
	// 			);
	// 		}),
	// 		map(() => {
	// 			return this.hideActionLoadingDispatcher;
	// 		}),
	// 	);

	// @Effect()
	// init$: Observable<Action> = defer(() => {
	//     const queryParams = new QueryParamsModel({});
	//     return of(new PickingPageRequested({ page: queryParams }));
	// });

	constructor(private actions$: Actions, private pickingService: PickingService, private store: Store<AppState>) {
	}
}
